import Nullstack from 'nullstack';
export default function IconHash({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-hash",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("line", {
    x1: "5",
    y1: "9",
    x2: "19",
    y2: "9"
  }), "   ", Nullstack.element("line", {
    x1: "5",
    y1: "15",
    x2: "19",
    y2: "15"
  }), "   ", Nullstack.element("line", {
    x1: "11",
    y1: "4",
    x2: "7",
    y2: "20"
  }), "   ", Nullstack.element("line", {
    x1: "17",
    y1: "4",
    x2: "13",
    y2: "20"
  }), " ");
}